import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/img/logo_color.svg';
const _withScopeId = n => (_pushScopeId("data-v-4705b4e0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "top-logo"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_3 = [_hoisted_2];
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "icons flex"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "line1"
}), /*#__PURE__*/_createElementVNode("span", {
  class: "line2"
}), /*#__PURE__*/_createElementVNode("span", {
  class: "line3"
})], -1));
const _hoisted_5 = [_hoisted_4];
const _hoisted_6 = {
  class: "slide-nav"
};
const _hoisted_7 = {
  key: 0
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_icon = _resolveComponent("van-icon");
  const _component_van_popup = _resolveComponent("van-popup");
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["top-header flex align-items", $data.active])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("a", {
    href: "javascript:;",
    onClick: _cache[0] || (_cache[0] = $event => $options.actionTo('/'))
  }, _hoisted_3)]), _createElementVNode("div", {
    class: "nav-icons",
    onClick: _cache[1] || (_cache[1] = (...args) => $setup.showPopup && $setup.showPopup(...args))
  }, _hoisted_5), _createVNode(_component_van_popup, {
    show: $setup.show,
    "onUpdate:show": _cache[14] || (_cache[14] = $event => $setup.show = $event),
    position: "right",
    style: {
      width: '68%',
      height: '100%'
    },
    closeable: ""
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_6, [_createElementVNode("nav", null, [_createElementVNode("ul", null, [_createElementVNode("li", {
      class: _normalizeClass($setup.checked['serviceHR'])
    }, [_createElementVNode("a", {
      href: "javascript:;",
      onClick: _cache[2] || (_cache[2] = $event => $options.actionTo('/'))
    }, "人力资源服务")], 2), _createElementVNode("li", {
      class: _normalizeClass($setup.checked['serviceVocation'])
    }, [_createElementVNode("a", {
      href: "javascript:;",
      onClick: _cache[3] || (_cache[3] = $event => $options.actionTo('/zhiye'))
    }, "职业教育服务")], 2), _createElementVNode("li", {
      class: _normalizeClass($setup.checked['serviceEdu'])
    }, [_createElementVNode("a", {
      href: "javascript:;",
      onClick: _cache[4] || (_cache[4] = $event => $options.actionTo('/edu'))
    }, "继续教育服务")], 2), _createElementVNode("li", {
      class: _normalizeClass($setup.checked['serviceXsc'])
    }, [_createElementVNode("a", {
      href: "javascript:;",
      onClick: _cache[5] || (_cache[5] = $event => $options.actionTo('/xsc'))
    }, "人力资源蓄水池")], 2), _createElementVNode("li", {
      class: _normalizeClass($setup.checked['about'])
    }, [_createElementVNode("a", {
      href: "javascript:;",
      onClick: _cache[6] || (_cache[6] = (...args) => $setup.showA && $setup.showA(...args))
    }, [_createTextVNode("关于爱沃客 "), $setup.showAbout == false ? (_openBlock(), _createBlock(_component_van_icon, {
      key: 0,
      name: "arrow-down"
    })) : (_openBlock(), _createBlock(_component_van_icon, {
      key: 1,
      name: "arrow-up"
    }))]), $setup.showAbout ? (_openBlock(), _createElementBlock("ul", _hoisted_7, [_createElementVNode("li", {
      class: _normalizeClass($setup.checked['aboutIntro'])
    }, [_createElementVNode("a", {
      href: "javascript:;",
      onClick: _cache[7] || (_cache[7] = $event => $options.actionTo('/about'))
    }, "企业介绍")], 2), _createElementVNode("li", {
      class: _normalizeClass($setup.checked['aboutHonor'])
    }, [_createElementVNode("a", {
      href: "javascript:;",
      onClick: _cache[8] || (_cache[8] = $event => $options.actionTo('/about/honor'))
    }, "资质荣誉")], 2), _createElementVNode("li", {
      class: _normalizeClass($setup.checked['aboutWenhua'])
    }, [_createElementVNode("a", {
      href: "javascript:;",
      onClick: _cache[9] || (_cache[9] = $event => $options.actionTo('/about/wenhua'))
    }, "企业文化")], 2), _createElementVNode("li", {
      class: _normalizeClass($setup.checked['aboutGongyi'])
    }, [_createElementVNode("a", {
      href: "javascript:;",
      onClick: _cache[10] || (_cache[10] = $event => $options.actionTo('/about/gongyi'))
    }, "沃公益")], 2), _createElementVNode("li", {
      class: _normalizeClass($setup.checked['aboutCompany'])
    }, [_createElementVNode("a", {
      href: "javascript:;",
      onClick: _cache[11] || (_cache[11] = $event => $options.actionTo('/about/company'))
    }, "合作伙伴")], 2)])) : _createCommentVNode("", true)], 2), _createElementVNode("li", {
      class: _normalizeClass($setup.checked['newsList'])
    }, [_createElementVNode("a", {
      href: "javascript:;",
      onClick: _cache[12] || (_cache[12] = $event => $options.actionTo('/news?t=' + Math.random()))
    }, "新闻动态")], 2), _createElementVNode("li", {
      class: _normalizeClass($setup.checked['contactUs'])
    }, [_createElementVNode("a", {
      href: "javascript:;",
      onClick: _cache[13] || (_cache[13] = $event => $options.actionTo('/contact'))
    }, "联系我们")], 2)])])])]),
    _: 1
  }, 8, ["show"])], 2);
}